import { render, staticRenderFns } from "./EditTicketModal.vue?vue&type=template&id=3675b244"
import script from "./EditTicketModal.vue?vue&type=script&lang=js"
export * from "./EditTicketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports